import { render } from "./IconArticles.vue?vue&type=template&id=1da462ea"
const script = {}
script.render = render

export default script